import React, { Component } from "react";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  "<ul> <li>To estimate in-season cropping pattern and crop condition using near-real-time satellite data&nbsp;</li> </ul> <ul> <li>To estimate in-season irrigation water demand at weekly/fortnightly time-step&nbsp;</li> </ul> <ul> <li>To quantify the water productivity variations across the command area and evaluate the performance of irrigation system.</li> </ul> <ul> <li>Development of a decision support system for irrigation scheduling</li> </ul>";

export default class IRProjObjective extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Satellite data based inputs for Irrigation Scheduling for a
                  selected Irrigation Project command area
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
